if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      this.productInfo = document.getElementById(`ProductInfo-${this.dataset.section}`);
      this.prependMedia = this.dataset.disablePrepend != 'true';
      if (this.productInfo && Shopify.postLinksRetry) this.productInfo.initShareLinks();
      this.filteringOption = this.dataset.filteringOption;
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      this.initScarpyNavigation();
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }

    initScarpyNavigation() {
      const slider = this.elements.viewer && this.elements.viewer.querySelector('.product__media-list');
      if (!slider || this.dataset.scarpyNavigationReady === 'true') return;
      this.dataset.scarpyNavigationReady = 'true';

      const mediaItems = () => Array.from(slider.children).filter((item) => item.dataset.mediaId && !item.classList.contains('hidden'));
      const activate = (requestedIndex) => {
        const items = mediaItems();
        if (!items.length) return;
        const index = Math.max(0, Math.min(requestedIndex, items.length - 1));
        const activeMedia = items[index];

        items.forEach((item) => item.classList.toggle('is-active', item === activeMedia));
        slider.scrollTo({ left: activeMedia.offsetLeft, behavior: 'smooth' });

        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${activeMedia.dataset.mediaId}"]`);
          this.setActiveThumbnail(activeThumbnail);
        }

        const dots = Array.from(this.elements.viewer.querySelectorAll('.slider-counter__link'));
        dots.forEach((dot, dotIndex) => {
          if (dotIndex === index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });

        const previous = this.elements.viewer.querySelector('.splide__arrow--prev');
        const next = this.elements.viewer.querySelector('.splide__arrow--next');
        if (previous) previous.disabled = index === 0;
        if (next) next.disabled = index === items.length - 1;
      };

      const currentIndex = () => {
        const items = mediaItems();
        if (!items.length) return 0;
        return items.reduce((best, item, index) => {
          const distance = Math.abs(item.offsetLeft - slider.scrollLeft);
          return distance < best.distance ? { index, distance } : best;
        }, { index: 0, distance: Infinity }).index;
      };

      this.addEventListener('click', (event) => {
        const button = event.target.closest && event.target.closest('button');
        if (!button || !this.contains(button)) return;

        let requestedIndex = null;
        if (button.classList.contains('splide__arrow--prev')) requestedIndex = currentIndex() - 1;
        if (button.classList.contains('splide__arrow--next')) requestedIndex = currentIndex() + 1;

        const thumbnail = button.closest('[data-target]');
        if (thumbnail && this.elements.thumbnails && this.elements.thumbnails.contains(button)) {
          requestedIndex = mediaItems().findIndex((item) => item.dataset.mediaId === thumbnail.dataset.target);
        }

        if (button.classList.contains('slider-counter__link')) {
          requestedIndex = Array.from(this.elements.viewer.querySelectorAll('.slider-counter__link')).indexOf(button);
        }

        if (requestedIndex == null || requestedIndex < 0) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.dataset.scarpyLastAction = String(requestedIndex);
        activate(requestedIndex);
      }, true);

      const bindControl = (control, direction) => {
        if (!control) return;
        control.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();
          activate(currentIndex() + direction);
        }, true);
      };

      bindControl(this.elements.viewer.querySelector('.splide__arrow--prev'), -1);
      bindControl(this.elements.viewer.querySelector('.splide__arrow--next'), 1);

      if (this.elements.thumbnails) {
        this.elements.thumbnails.querySelectorAll('[data-target] button').forEach((button) => {
          button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopImmediatePropagation();
            const target = button.closest('[data-target]') && button.closest('[data-target]').dataset.target;
            const index = mediaItems().findIndex((item) => item.dataset.mediaId === target);
            if (index >= 0) activate(index);
          }, true);
        });
      }

      this.elements.viewer.querySelectorAll('.slider-counter__link').forEach((dot, index) => {
        dot.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();
          activate(index);
        }, true);
      });
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend, filtering = false, currentVariant = null) {
      if (filtering && currentVariant) {
        const allSlides = this.querySelectorAll('.product__media-item, .thumbnail-list__item, .slider-counter__link');
        allSlides.forEach(slide => {
          if (slide.dataset.alt === currentVariant[this.filteringOption] || slide.dataset.alt === 'always_display') {
            slide.classList.remove('hidden');
          } else {
            slide.classList.add('hidden');
          }
        })
      }

      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend && this.prependMedia) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (filtering && currentVariant) {
        if (this.elements.viewer && this.elements.viewer.initPages) this.elements.viewer.initPages();
        if (this.elements.viewer && this.elements.viewer.update) this.elements.viewer.update();
      }

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, false, 10, true)) return;

      if (this.elements.thumbnails.vertical) {
        console.log('setActiveThumbnail')
        this.elements.thumbnails.slider.scrollTo({ top: thumbnail.offsetTop });
      } else {
        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
